import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'register', 'registerResult'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar

  if (window.abp.session.userId) {
    if(!store.getters.initRouters){
      store.dispatch('GenerateRoutes', {  }).then(() => {
        // 根据roles权限生成可访问的路由表
        // 动态添加可访问路由表
        router.addRoutes(store.getters.addRouters)
        if (to.path === '/user/login') {
          next({ path: '/dashboard/analysis' })
          NProgress.done()
        } else {
          const redirect = decodeURIComponent(from.query.redirect || to.path)
          if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            next({ ...to, replace: true })
          } else {
                // 跳转到目的路由
            next({ path: redirect })
          }
        }
      })    
      
    }else{
      if (to.path === '/user/login') {
        next({ path: '/dashboard/workplace' })
        NProgress.done()
      } else {
        next()
      }
    }
    
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
